import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

class VehiclePhotos extends Component {
  state = {
    rows: [],
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  loadData = (props) => {
    const rows = [];
    if (props.record !== undefined) {
      const roots = _.get(props.record, "stockPhotos[0].stockPhoto");
      if (roots === undefined) {
        rows.push(
          <Table.Row key={`veh_no_photo_${props.detailIndex}`}>
            <Table.Cell colSpan={100}>No sample photo available</Table.Cell>
          </Table.Row>
        );
      } else {
        _.forEach(roots, (root, index) => {
          const src = _.get(root, "_");
          rows.push(
            <Table.Row key={`veh_phot_cap_${index}`}>
              <Table.Cell colSpan={100}>
                <Table key={`veh_phot_${index}`}>
                  <Table.Body>
                    <Table.Row>
                      {/* <Table.Cell>
                        <img
                          src={src}
                          alt="vehicle"
                          className="vehicle-photo"
                        />
                      </Table.Cell> */}
                      <Table.Cell>{src}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }
    this.setState({ rows });
  };
  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row key={`vin_samp_photo_row`}>
            <Table.HeaderCell
              colSpan={100}
              className="report-sub-section-header text-center"
            >
              Sample Vehicle Photos
            </Table.HeaderCell>
          </Table.Row>
          {this.state.rows}
        </Table.Body>
      </Table>
    );
  }
}

export default VehiclePhotos;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/VehiclePhotos.js